import Vue from 'vue'
import { GetterTree, MutationTree } from "vuex"

import { getResource } from "~/utils/store"
import { RootState } from "~/store/store.types"

import { RatePlansState, RatePlanResource } from "~/store/rate_plans/rate-plan.types"

export const state = (): RatePlansState => ({
  data: {},
  filters: {}
})

export const getters: GetterTree<RatePlansState, RootState> = {
  resourceById (state, _, __, rootGetters) {
    return (id: string, included: string | string[] = []) =>
      getResource<RatePlanResource>(state, id, rootGetters, included)
  }
}

export const mutations: MutationTree<RatePlansState> = {
  SET_RATE_PLAN (state, ratePlan: RatePlanResource) {
    const { id } = ratePlan

    Vue.set(state.data, id, ratePlan)
  }
}
